<template>
  <div class="submit-container">
    <div
      class="close"
      v-if="visibleCoinList"
      @click="visibleCoinListHandle(false)"
    ></div>
    <div class="main">
      <div class="agree" :class="{ warn: showWarn }">
        <a href="javascript:;" @click="agreeItem">
          <em class="check" :class="{ checked: boolAgree }"></em>
          {{ letter.meAgree }}&nbsp
        </a>
        <a href="javascript:;" @click="showCoinsAgree">{{
          letter.abountZbit.replace('\${Z-BIT}', getCoinsName)
        }}</a>
        <span>&nbsp{{ letter.and }}&nbsp</span>
        <a :href="serviceLink" target="_blank">{{ letter.fwtk }}</a>
      </div>
      <div class="selected">
        <p class="selected-title">{{ letter.storeHasSelect }}：</p>
        <a
          href="javascript:;"
          class="selected-cont"
          @click="visibleCoinListAuto"
        >
          <span class="selected-cont-desc"
            >{{ getCoinsName }}- {{ curCoins.TRANS_AMOUNT }}
            {{ curCoins.CURRENCY }}</span
          >
          <em class="selected-cont-arrow"></em>
        </a>
      </div>
      <div class="bar">
        <p class="bar-price">
          {{ letter.storeTotal }}:
          <span class="price-total"
            >{{ curCoins.TRANS_AMOUNT }} {{ curCoins.SHOW_CURRENCY }}</span
          >
          <span v-if="isShowTax">{{
            `+${curTax}${curCoins.SHOW_CURRENCY}(tax)`
          }}</span>
        </p>
        <Button class="bar-submit" @click="postOrder" :loading="submitLoading">
          {{ isBankPay ? '獲取匯款帳號' : letter.submitOrder }}
        </Button>
      </div>
    </div>
    <transition name="slide-up">
      <div class="coins" v-if="visibleCoinList">
        <div class="coins-tabs">
          <a
            href="javascript:;"
            class="coins-tabs-item"
            :class="{ active: curSortType === 'default' }"
            data-sort="default"
            @click="changeSortType"
            >{{ letter.orderNormal }}</a
          >
          <a
            href="javascript:;"
            class="coins-tabs-item"
            :class="{ active: curSortType === 'lowToHeight' }"
            data-sort="lowToHeight"
            @click="changeSortType"
            >{{ letter.orderPriceUp }}</a
          >
          <a
            href="javascript:;"
            class="coins-tabs-item"
            :class="{ active: curSortType === 'heightToLow' }"
            data-sort="heightToLow"
            @click="changeSortType"
            >{{ letter.orderPriceDown }}</a
          >
        </div>
        <ul class="coins-list scroll">
          <li
            class="coins-list-item"
            v-for="(item, key) in sortCoinsList"
            :key="item.TRANS_AMOUNT + key"
          >
            <a
              href="javascript:;"
              class="coin"
              :class="{
                active:
                  curCoins.TRANS_AMOUNT === item.TRANS_AMOUNT &&
                  curCoins.CURRENCY === item.CURRENCY
              }"
              @click="changeCoinItem(item)"
            >
              <p class="coin-desc">
                {{ getCoinsName }} - {{ item.TRANS_AMOUNT }}
                {{ item.CURRENCY }}
              </p>
            </a>
          </li>
        </ul>
        <div class="coins-line"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  UPDATE_IS_AGREE_COINS_PAY,
  setHasPayCoinsUid
} from '@store/officialStore/coins';
import serviceLink from '@mixins/officialStore/serviceLink';
import zipcode from '@mixins/officialStore/zipcode';

export default {
  name: 'CoinsSubmitFooter',
  mixins: [serviceLink, zipcode],
  props: ['coinsList', 'curCoins', 'submitLoading', 'isBankPay'],
  data() {
    return {
      visibleCoinList: false,
      curSortType: 'lowToHeight',
      sortCoinsList: [],
      boolAgree: false,
      showWarn: false
    };
  },
  created() {
    if (this.$route.name === 'coins') {
      window.webstorev1DataLayer.push({
        eventName: 'select_product',
        eventType: 'balance_select',
        eventReason: 'auto_select',
        eventValue: {
          product_type: '',
          cp_product_id: '',
          product_id: '',
          product_num: 1,
          product_currency: this.curCoins.CURRENCY || '',
          product_money: this.curCoins.TRANS_AMOUNT || ''
        }
      });
    }
  },
  computed: {
    isShowTax() {
      return +this.curTax > 0 && this.curLocation === 'US';
    },
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      isAgreeCoinsPay: state => state.coins.isAgreeCoinsPay,
      uid: state => state.login.uid,
      curLocation: state => state.curLocation,
      zipCode: state => state.zipCode,
      curTax: state => state.curTax
    }),
    ...mapGetters(['getCoinsName'])
  },
  watch: {
    coinsList: {
      immediate: true,
      handler() {
        this.sortByLowToHeight();
      }
    },
    isAgreeCoinsPay: {
      immediate: true,
      handler(newVal) {
        this.boolAgree = newVal;
      }
    },
    curCoins: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.curLocation === 'US' && newVal) {
          this.getCurrentTax({
            zipCode: this.zipCode,
            amount: newVal.TRANS_AMOUNT,
            currency: newVal.SHOW_CURRENCY
          });
        }
      }
    }
  },
  methods: {
    showCoinsAgree() {
      this.$emit('showCoinsAgree');
    },
    agreeItem() {
      this.boolAgree = !this.boolAgree;
      if (this.boolAgree) {
        // 如果是代币储值的话，保存用户的uid，在uid登录初始化的勾选协议的时候使用
        setHasPayCoinsUid(this.uid);
        this.$store.commit(UPDATE_IS_AGREE_COINS_PAY, true);
      }
    },
    postOrder() {
      if (this.isAgreeCoinsPay && this.boolAgree) {
        this.$emit('postOrder');
        return;
      }
      if (this.boolAgree) {
        this.$emit('postOrder');
      } else {
        this.showWarn = true;
      }
    },
    changeCoinItem(curCoins) {
      console.log('curCoins:', curCoins);
      window.webstorev1DataLayer.push({
        eventName: 'select_product',
        eventType: 'balance_select',
        eventReason: 'click_select',
        eventValue: {
          product_type: '',
          cp_product_id: '',
          product_id: '',
          product_num: 1,
          product_currency: curCoins.CURRENCY || '',
          product_money: curCoins.TRANS_AMOUNT || ''
        }
      });
      this.$emit('updateCurCoins', curCoins);
      this.visibleCoinListHandle(false);
    },
    visibleCoinListHandle(bool) {
      this.visibleCoinList = bool;
    },
    visibleCoinListAuto() {
      this.visibleCoinList = !this.visibleCoinList;
    },
    changeSortType(e) {
      const sortType = e.target.dataset.sort;
      const handleMap = {
        default: this.sortByDefault,
        lowToHeight: this.sortByLowToHeight,
        heightToLow: this.sortByHeightToLow
      };
      const sortHandle = handleMap[sortType];
      if (!sortHandle) return;
      this.curSortType = sortType;
      sortHandle();
    },
    sortByDefault() {
      try {
        // 复制一个新的数组
        this.sortCoinsList =
          this.coinsList && JSON.parse(JSON.stringify(this.coinsList));
      } catch (e) {
        this.sortCoinsList = [];
        console.error(e);
      }
    },
    sortByLowToHeight() {
      this.sortByDefault();
      this.sortCoinsList.sort((a, b) => {
        return a.TRANS_AMOUNT - b.TRANS_AMOUNT;
      });
    },
    sortByHeightToLow() {
      this.sortByDefault();
      this.sortCoinsList.sort((a, b) => {
        return b.TRANS_AMOUNT - a.TRANS_AMOUNT;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';

@keyframes slideTopDown {
  from {
    transform: translate3d(0, -3px, 0);
  }
  to {
    transform: translate3d(0, 2px, 0);
  }
}

.submit-container {
  z-index: 8;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 260px;
  font-size: 0;
}

.close {
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.main {
  z-index: 12;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 260px !important;
  background-size: 100% 100%;
  @psetbg ('coins-submit-bg.png');
}

.agree {
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  padding: 0 36px;
  background-color: #ffffff;
  border: 1px solid #cbb3ae;
  line-height: 38px;
  color: #333333;

  .check {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-top: 6px;
    margin-right: 2px;
    border: 1px solid #cbb3ae;

    &.checked {
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        width: 18px;
        height: 18px;
        transform: translate(-50%, -50%);
        background-color: #cbb3ae;
      }
    }
  }

  a,
  em,
  span {
    font-size: 20px;
    vertical-align: top;
    color: #333333;
  }

  &.warn {
    background-color: #ebe7e0;
    border-color: #90352b;
    .check {
      border-color: #90352b;
      &.checked {
        &::after {
          background-color: #90352b;
        }
      }
    }

    a,
    i,
    span {
      color: #90352b;
    }
  }
}

.coins {
  z-index: 11;
  box-sizing: border-box;
  position: absolute;
  bottom: 257px;
  left: 0;
  width: 100% !important;
  padding: 34px 36px;
  background-size: 100% 100%;
  @psetbg ('coins-submit-bg.png');
  height: 450px !important;
  &-tabs {
    &-item {
      display: inline-block;
      min-width: 118px;
      height: 40px;
      margin-right: 24px;
      padding: 0 26px;
      font-size: 28px;
      background-color: #b99753;
      line-height: 40px;
      text-align: center;
      color: #664339;
      &.active {
        background-color: #2d2d2d;
        color: #fff;
      }
    }
  }
  &-list {
    $rightMargin: 4px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    width: 100%;
    // width: calc(100% + 10px + $rightMargin);
    height: 334px;
    margin-top: 34px;
    padding-right: $rightMargin;
    padding-bottom: 30px;
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }
    &-item {
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
      .coin {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 80px;
        padding: 0 26px;
        border: 1px solid #ccc;

        &.active {
          border-color: var(--submit-discount);
        }
        &-desc {
          flex: 1;
          font-size: 30px;
          font-weight: bold;
          color: #000000;
        }
        &-tag {
          display: inline-block;
          min-width: 80px;
          height: 26px;
          padding: 0 18px;
          background-color: #b99753;
          line-height: 26px;
          font-size: 18px;
          text-align: center;
          color: #664339;
        }
      }
    }
  }
  &-line {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 2px;
    margin: auto;
    background-color: #a8a7a7;
  }
}

.selected {
  z-index: 12;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 26px 36px 0;
  margin-bottom: 24px;

  &-title {
    font-size: 30px;
    font-weight: bold;
    line-height: 80px;
    white-space: nowrap;
    color: #000;
  }
  &-cont {
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 80px;
    padding: 0 72px 0 16px;
    border: 1px solid var(--submit-discount);
    &-desc {
      line-height: 80px;
      font-size: 30px;
      font-weight: bold;
      color: #000;
    }
    &-arrow {
      position: absolute;
      display: inline-block;
      top: 0;
      bottom: 0;
      right: 26px;
      margin: auto;
      cursor: pointer;
      animation: slideTopDown 0.8s ease infinite alternate-reverse;
      @psetbg ('coins-pay-arrow.png');
    }
  }
}

.bar {
  z-index: 12;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 36px;
  font-size: 30px;
  color: var(--submit-discount);
  &-price {
    line-height: 71px;
    font-weight: bold;
  }
  &-submit {
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    font-size: 24px;
    color: var(--submit-btn);
    cursor: pointer;
    @psetbg ('submit.png');
  }
}

@media screen and (orientation: landscape) {
  .main,
  .coins {
    left: 50%;
    width: 1202px !important;
    transform: translateX(-50%);
  }
  .coins {
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
